import matter from 'gray-matter';
import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

export interface PostData {
  slug: string;
  title: string;
  date?: string;
  excerpt?: string;
  content: string;
  author?: string;
  reportedBy?: string;
  order?: number;
  status?: 'completed' | 'in-progress' | 'planned' | 'reported' | 'sprint' | 'testing' | 'resolved' | 'review' | 'archived';
  priority?: 'low' | 'medium' | 'high';
  urgency?: 'low' | 'medium' | 'high';
  type?: 'bug' | 'feature' | 'improvement';
}

interface RegistryItem {
  slug: string;
  path: string;
  status?: string;
}

export const getAllPosts = async (type: 'blog' | 'docs' | 'roadmap' | 'support' | 'legal' | 'about'): Promise<PostData[]> => {
  try {
    const response = await fetch('/content/registry.json');
    const registry = await response.json();
    const items: RegistryItem[] = registry[type] || [];

    const posts = await Promise.all(items.map(async (item) => {
      const res = await fetch(item.path);
      if (!res.ok) return null;
      const text = await res.text();
      const { data, content: body } = matter(text);

      return {
        slug: item.slug,
        content: body,
        title: data.title || item.slug,
        date: data.date,
        excerpt: data.excerpt,
        author: data.author,
        reportedBy: data.reportedBy,
        order: data.order,
        status: item.status || data.status,
        priority: data.priority,
        urgency: data.urgency,
        type: data.type,
      } as PostData;
    }));

    const filteredPosts = posts.filter((p): p is PostData => p !== null);

    return filteredPosts.sort((a, b) => {
      if (type === 'blog') {
        return new Date(b.date || '').getTime() - new Date(a.date || '').getTime();
      }
      return (a.order || 0) - (b.order || 0);
    });
  } catch (error) {
    console.error("Error fetching posts:", error);
    return [];
  }
};

export const getPostBySlug = async (type: 'blog' | 'docs' | 'roadmap' | 'support' | 'legal' | 'about', slug: string): Promise<PostData | null> => {
  const posts = await getAllPosts(type);
  return posts.find(p => p.slug === slug) || null;
};